import type { ReactNode } from 'react';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';

import './BannerFill.scss';

export interface BannerFillProps {
  variant: 'danger' | 'warning';
  inline?: boolean;
  icon?: ReactNode;
  title: string;
  description?: string;
  trailing?: ReactNode;
  screenReaderLabel?: string;
  regularText?: boolean;
  onClose?: () => void;
  closeLabel?: string;
}

export default function BannerFill({
  variant,
  inline,
  icon,
  title,
  description,
  trailing,
  screenReaderLabel,
  regularText,
  onClose,
  closeLabel
}: Readonly<BannerFillProps>) {
  const classes = [
    'banner-fill-style',
    `banner-fill-style--${variant}`,
    inline && 'banner-fill-style--inline',
    regularText && 'banner-fill-style--regular-text'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {icon && <span className="banner-fill-style__icon">{icon}</span>}
      <div className="banner-fill-style__content">
        {title && (
          <div className="banner-fill-style__title">
            {screenReaderLabel && <span className="sr-only">{screenReaderLabel} </span>}
            {title}
          </div>
        )}
        {description && <div className="banner-fill-style__desc">{description}</div>}
      </div>
      {trailing && <div className="banner-fill-style__trailing">{trailing}</div>}
      {onClose && (
        <button type="button" className="banner-fill-style__close" onClick={onClose} aria-label={closeLabel}>
          <CloseIcon aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
